// src/components/WarbandPDFStyles.js
import { StyleSheet } from '@react-pdf/renderer'; // Removed Font import if registration is in the component

export const styles = StyleSheet.create({
  // ... existing styles ...
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    fontFamily: 'Cinzel',
  },
  warbandName: {
    textAlign: 'center',
    fontSize: 24,
    marginBottom: 20,
    fontFamily: 'Cinzel',
    color: '#5a4632',
    minHeight: 25,
    flexShrink: 0,
  },
  cardContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
  card: {
    border: '1pt solid #d4c5a6',
    borderRadius: 5,
    padding: 12,
    backgroundColor: '#fdf5e6',
    width: '45%',
    margin: '2.5%',
    fontSize: 10,
    color: '#5a4632',
    minHeight: 450, // Adjust if Notes makes cards taller
    boxSizing: 'border-box',
  },
  cardTitle: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 8,
    fontFamily: 'Cinzel',
  },
  statsContainer: {
    flexDirection: 'row',
    marginBottom: 8,
    marginTop: 8,
  },
  statsColumn: {
    flex: 1,
  },
  paragraph: {
    fontSize: 9,
    marginBottom: 3,
  },
  label: {
    fontWeight: 'bold', // Use strings like 'bold' or numbers like 700
  },
  divider: {
    borderBottom: '1pt solid #d4c5a6',
    marginVertical: 8,
  },
  list: {
    paddingLeft: 10,
  },
  listItem: {
    fontSize: 9,
    marginBottom: 2,
  },
  // --- Add Style for Notes Section ---
  notesSection: {
    marginTop: 8, // Add some space above notes
  },
  notesText: {
    fontSize: 9,
    // Add more styling if needed (e.g., fontStyle: 'italic')
  }
  // --- End Notes Style ---
});
